<template>
  <div v-if="isLoginValid && !$route.meta.showCompletionMessages">
    <div class="alert alert-danger small mb-0 rounded-0 alert-dismissible fade show" role="alert" v-if="!statusComplete">
      Hummm, Parece que seu cadastro não esta completo, isso pode te atrapalhar. <a href="#" @click.prevent="showEditUser"> Clique Aqui</a> e finalize ele.
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="alert alert-warning small mb-0 rounded-0" role="alert" v-if="!emailVerified">
      Opss, seu email não foi verificado. <a href="#" @click.prevent="confirmEmail"> Clique Aqui</a> para enviarmos um novo email pra você.
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <!-- <div class="alert alert-link small mb-0 rounded-0" role="alert" v-if="user.type == 'TCH' && statusComplete && !authMarketPlace">
      Olha!!! Você ainda não autorizou tranzações para a sua conta <a :href="authorizationURL" target="_blank"> Clique Aqui</a> para resolvermos isso.
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Axios from 'axios'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      isLoginValid: false,
    }
  },
  computed: {
    ...mapGetters({
      isLogged: "getLoggedState",
      statusComplete: "statusComplete",
      emailVerified: "emailVerified",
      authMarketPlace: "authMarketPlace",
      user: "getCurrentUser"
    }),

    authorizationURL: function () {
      let mpID = process.env.VUE_APP_MP_ID
      let returnUrl = process.env.VUE_APP_RETURN_URL + this.user.document
      return `https://auth.mercadopago.com.br/authorization?client_id=${mpID}&response_type=code&platform_id=mp&redirect_uri=${returnUrl}`
    }
  },
  methods: {
    showEditUser: function () {
      $("#user-data-modal").modal('show')
    },
    confirmEmail: function () {
      Axios.post('/auth/confirm/email', {
        'email': this.user.email
      })
        .then( () => {
          Swal.fire({
            icon: 'success',
            title: 'Otimo!',
            text: 'Um email será enviado para você'
          })
        })
        .catch( err => {
          Swal.fire({
            icon: 'error',
            title: 'Opss!',
            text: 'Algo deu errado, tente novamente mais tarde'
          })
        })
    },

    updateLogin: function () {
      this.isLogged
        .then( logged => {
          this.isLoginValid = logged;
          this.showModalCompleteRegister()
        })
    },

    showModalCompleteRegister: function () {
      if (this.isLoginValid && !this.statusComplete) {
        Swal.fire({
          icon: "success",
          title: 'Olá &nbsp;<span class="text-akademica">Akdemico!!!</span>',
          html: `Que bom ver você aqui mais uma vez! &#129321
            <br>E para que você possa usufruir 100% da nossa plataforma a gente
            precisa de mais alguns dados seus.`,
          confirmButtonText: "Tudo bem, vamos lá &#128513"
        })
          .then(() => {
            $("#user-data-modal").modal('show')
          });
      }
    }
  },
  mounted () {
    this.showModalCompleteRegister()
  }
}
</script>
